export function LoadingGrid({ count = 8 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i}>
          <div className="aspect-poster animate-pulse rounded-lg bg-neutral-800" />
          <div className="mt-2 h-3.5 animate-pulse rounded bg-neutral-800" />
          <div className="mt-1.5 h-3 w-2/3 animate-pulse rounded bg-neutral-800" />
        </div>
      ))}
    </div>
  );
}

export function ErrorMessage({
  title,
  message,
  onRetry,
}: {
  title: string;
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="grid place-items-center py-16 text-center">
      <div>
        <p className="text-base font-medium">{title}</p>
        <p className="mt-1 text-sm text-neutral-400">{message}</p>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="mt-4 rounded-md border border-neutral-700 bg-neutral-800 px-4 py-2 text-sm hover:border-neutral-500"
          >
            Coba lagi
          </button>
        )}
      </div>
    </div>
  );
}

export function EmptyState({ message }: { message: string }) {
  return (
    <div className="grid place-items-center py-16 text-center text-sm text-neutral-500">
      {message}
    </div>
  );
}
